import { render, staticRenderFns } from "./CarregadorDeArquivosInput.vue?vue&type=template&id=6457a80a&scoped=true"
import script from "./CarregadorDeArquivosInput.vue?vue&type=script&lang=js"
export * from "./CarregadorDeArquivosInput.vue?vue&type=script&lang=js"
import style0 from "./CarregadorDeArquivosInput.vue?vue&type=style&index=0&id=6457a80a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6457a80a",
  null
  
)

export default component.exports